import React, { Component } from 'react'
import BookingInput from '../Booking/bookinginput';
import { connect } from 'react-redux';
import {updateProfile, addToast} from "../../actions/index";
import ButtonLoader from '../btnloader';
import { saveLocalState, ajaxerrmsg } from '../../actions/http';
import LogoutButton from './logoutbutton';
import usericon from "../../assets/images/user.png";

class UpdateProfile extends Component {
    constructor(props){
        super(props);
        this.state = {
            username: this.props.user.data.username || '',
            email: this.props.user.data.email || '',
            first_name: this.props.user.data.first_name || '',
            username_err: '',
            email_err: '',
            first_name_err: '',
            profile_pic: this.props.user.data.profile_pic || '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.fileInput = React.createRef();
    }

    handleChange(e){
        let {value, name} = e.target;
        this.setState({
            [name]: value,
            [name + "_err"]: ''
        })
    }

    handleSubmit(e){
        e.preventDefault();
        let {username, first_name, email} = this.state;
        let postData = new FormData();
        postData.append("username", username);
        postData.append("first_name", first_name);
        postData.append("email", email);
        if(this.fileInput.current.files.length > 0){
            postData.append("profile_pic", this.fileInput.current.files[0]); 
        }
        this.props.updateProfile(postData);
    }

    handleFileChange = (e) => {
        let files = e.target.files;
        if(files.length > 0){
            this.setState({
                profile_pic: URL.createObjectURL(files[0])
            })
        }
    }

    componentWillReceiveProps(nextProps){
        let {addToast, user} = nextProps;
        let {update_profile_success , update_profile_error, logout} = user;
        if(update_profile_success && !this.props.user.update_profile_success && !logout){
            addToast("Profile Updated Successfully");
            saveLocalState(nextProps.user.data);
        }
        if(update_profile_error && !this.props.user.update_profile_error){
            addToast(ajaxerrmsg(update_profile_error) , false);
        }
    }

    render() {
        let {username, username_err, email, email_err, first_name, first_name_err, profile_pic} = this.state;
        let { is_profile } = this.props.user.data;
        return (
            <div className="container-fluid">
                <div className="flex-between">
                    <h3>{this.props.user.data.first_name || 'Profile'}</h3>
                    <LogoutButton />
                </div>
                <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
                    <div className="m-b-20">
                        <div className="flex-center">
                            <div className="update-image-holder">
                                <img  src={profile_pic || usericon} alt={this.props.user.data.first_name || 'Profile'} />
                                <label className="update-image-edit flex-center">
                                    <input ref={this.fileInput} type="file" onChange={this.handleFileChange}  className="hide" accept="image/*"  />
                                    <i className="fas fa-pencil-alt"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <BookingInput  size={12} type="text" onChange={this.handleChange} value={first_name} err={first_name_err} name="first_name" placeholder="Name *"/>
                        <BookingInput readOnly={is_profile} size={12} type="number" maxLength={10} onChange={this.handleChange} value={username} err={username_err} name="username" placeholder="Phone Number *"/>
                        <BookingInput readOnly={is_profile} size={12} type="text" onChange={this.handleChange} value={email} err={email_err} name="email" placeholder="Email Address *"/>
                    </div>
                    <div className="modalfooter">
                        <button 
                            type='submit'
                            onSubmit={this.handleSubmit}
                            disabled={username && email && first_name && !this.props.user.fetching ? false : true} 
                            className="btn btn-block btn-ouja m-b-5 m-t-10"
                        >
                            {this.props.user.update_profile_fetching ? <ButtonLoader /> : 'Update Profile'}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}


const mapStateToProps = ({loginReducer}) => ({
    user: loginReducer
})

const mapDispatchToProps = {
    updateProfile,
    addToast
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile)